import React, { memo } from 'react';
import type { FunctionComponent } from 'react';
import { editBtnHandler, headingHandler, HeadingClass, IconClass, DataCradRowContentProps } from './utils';
import { addSpacesInNumbers, getClasses } from '@utils';
import { Icon } from '@web-components-proxy';

export const DataCradRowContent: FunctionComponent<DataCradRowContentProps> = memo(
	({ title, value, totalValue, customValue, suffix, isEditable, editPermission, logAmount, openModal, additionalClassName, severity }) => {
		const hasEditBtn = editPermission && isEditable;
		const hasAdditionalMargin = editPermission && !isEditable;
		const stringValue = String(value);
		const logAmountString = logAmount != null ? addSpacesInNumbers(String(logAmount)) + ' / ' : '';
		const stringSuffix = suffix ? ` ${suffix}` : '';
		const hasAdditionalClassName = !!additionalClassName;
		const additionalClassNameValue = additionalClassName || '';
		
		if (typeof value === 'number') {
			if (totalValue === 0) {
				return (
					<div
						className={getClasses({
							'data-row': true,
							'data-row--pd-non-editable': hasAdditionalMargin,
							'data-row--editable': hasEditBtn,
							[additionalClassNameValue]: hasAdditionalClassName
						})}
					>
						{headingHandler(HeadingClass.FALSE, title)}
						<div className="data-row__value-wrapper">
							<Icon class={IconClass.FALSE} iconName="cross"></Icon>
							{hasEditBtn && !!openModal && editBtnHandler(openModal)}
						</div>
					</div>
				);
			}
			const mainValuePart = (value > 0 || totalValue) ? addSpacesInNumbers(stringValue) : '-';
			const totalValuePart = totalValue === undefined ? '' : ` / ${addSpacesInNumbers(String(totalValue))}`;
			const customValuePart = customValue ? ` + ${addSpacesInNumbers(String(customValue))}` : '';

			return (
				<div
					className={getClasses({
						'data-row': true,
						'data-row--pd-non-editable': hasAdditionalMargin,
						'data-row--editable': hasEditBtn,
						[additionalClassNameValue]: hasAdditionalClassName
					})}
				>
					{headingHandler(HeadingClass.CONTENT, title)}
					<div className="data-row__value-wrapper">
						<span key="value" className="data-row__value">
							{mainValuePart}
							{totalValuePart}
							{customValuePart}
							{stringSuffix}
						</span>
						{hasEditBtn && !!openModal && editBtnHandler(openModal)}
					</div>
				</div>
			);
		}

		if (typeof value === 'boolean') {
			const iconClass = value ? IconClass.TRUE : IconClass.FALSE;

			return (
				<div
					className={getClasses({
						'data-row': true,
						'data-row--pd-non-editable': hasAdditionalMargin,
						'data-row--editable': hasEditBtn,
						[additionalClassNameValue]: hasAdditionalClassName
					})}
				>
					{headingHandler(value ? HeadingClass.TRUE : HeadingClass.FALSE, title)}
					<div className="data-row__value-wrapper">
						<Icon class={iconClass} iconName={value ? 'checkbox' : 'cross'}></Icon>
						{hasEditBtn && !!openModal && editBtnHandler(openModal)}
					</div>
				</div>
			);
		}

		if (typeof value === 'object' && value) {
			return (
				<div
					className={getClasses({
						'data-row': true,
						'data-row--pd-non-editable': hasAdditionalMargin,
						'data-row--editable': hasEditBtn,
						[additionalClassNameValue]: hasAdditionalClassName
					})}
				>
					{headingHandler(HeadingClass.CONTENT, title)}
					<div className="data-row__value-wrapper">
						{value}
						{hasEditBtn && !!openModal && editBtnHandler(openModal)}
					</div>
				</div>
			);
		}

		if (value === null || value === '') {
			if (typeof customValue === 'number' && !!customValue) {
				return (
					<div
						className={getClasses({
							'data-row': true,
							'data-row--pd-non-editable': hasAdditionalMargin,
							'data-row--editable': hasEditBtn,
							[additionalClassNameValue]: hasAdditionalClassName
						})}
					>
						{headingHandler(HeadingClass.TRUE, title)}
						<div className="data-row__value-wrapper">
							<span key="value" className="data-row__value">
								{`${addSpacesInNumbers(String(customValue))}${stringSuffix}`}
							</span>
							{hasEditBtn && !!openModal && editBtnHandler(openModal)}
						</div>
					</div>
				);
			}

			return (
				<div
					className={getClasses({
						'data-row': true,
						'data-row--pd-non-editable': hasAdditionalMargin,
						'data-row--editable': hasEditBtn,
						[additionalClassNameValue]: hasAdditionalClassName
					})}
				>
					{headingHandler(HeadingClass.TRUE, title)}
					<div className="data-row__value-wrapper">
						<span key="value" className="data-row__value">
							{hasEditBtn ? value : '-'}
						</span>
						{hasEditBtn && !!openModal && editBtnHandler(openModal)}
					</div>
				</div>
			);
		}

		return (
			<div
				className={getClasses({
					'data-row': true,
					'data-row--pd-non-editable': hasAdditionalMargin,
					'data-row--editable': hasEditBtn,
					[additionalClassNameValue]: hasAdditionalClassName,
					[`data-row--${severity}`]: !!severity
				})}
			>
				{headingHandler(HeadingClass.CONTENT, title)}
				<div className="data-row__value-wrapper">
					<span key="value" className="data-row__value">
						{`${logAmountString}${stringValue}${stringSuffix}`}
					</span>
					{hasEditBtn && !!openModal && editBtnHandler(openModal)}
				</div>
			</div>
		);
	},
);
